export default {
	app: {
		brand_zh: 'Ulucu',
		brand_en: 'ULUCU',
	},
	common: {
		todo_module: 'Module not implemented yet, in development',
		loading: 'Loading…',
		no_data: 'No data',
		select_store: 'Select store',
		show_raw: 'Show raw response',
		reload: 'Reload',
		filter: 'Filter',
		cancel: 'Cancel',
		back: 'Back',
	},
	group: {
		core: 'Core',
		major: 'Major',
		support: 'Support',
		value_add: 'Add-ons',
	},
	tabbar: {
		monitor: 'Monitor',
		home: 'Home',
		store: 'Store',
		application: 'Application',
		incidents: 'Incidents',
		analytics: 'Analytics',
		operations: 'Operations',
		account: 'Account',
		video: 'Video',
		reports: 'Reports',
		workbench: 'Workbench',
		messages: 'Messages',
		profile: 'My',
		messages_title: 'Message Center',
		reports_title: 'Customer Analytics',
	},
	ops: {
		title: 'Operations',
		subtitle: 'Store patrol, AI inspection, and device workflows',
		available: 'Available',
		permission_required: 'Needs setup',
		empty: 'No available tools',
		view_status: 'View status',
	},
	capability: {
		available_short: 'Available in this region',
		permission_required_short: 'Requires admin enablement',
		unknown_short: 'API coverage pending',
		region_unavailable_short: 'Unavailable in this region',
		permission_required_desc: 'You do not have the right to this module.',
		unknown_desc: 'This APAC/Mexico capability needs API verification before it is exposed to users.',
		region_unavailable_desc: 'This capability belongs to the China deployment and should not be exposed in APAC/Mexico.',
		back_to_operations: 'Back to Operations',
	},
	root: {
		monitor: {
			subtitle: 'Store video, device health, and multi-view monitoring',
			store_count: 'Stores',
			online_devices: 'Online devices',
			offline_devices: 'Offline devices',
			favorites: 'Favorites',
			tools: 'Monitoring Tools',
			stores: 'Stores & Channels',
			offline_action: 'View offline stores',
			offline_filter_active: 'Filtering offline',
			tool_store: 'Store Management',
			tool_store_hint: 'Review store profiles, groups, and operating status',
			tool_device: 'Device Status',
			tool_device_hint: 'Check device connectivity and channel status',
			tool_multi_view: 'Multi-view',
			tool_multi_view_hint: 'Choose a store before opening multi-channel view',
			tool_multi_view_empty: 'No stores available',
			multi_view_select_store: 'Choose store',
			multi_view_store_count: '{{online}}/{{total}} online',
			multi_view_no_online: 'No online channels',
		},
		analytics: {
			subtitle: 'Traffic, members, vehicles, and business insights',
			visible_modules: 'Visible modules',
			primary_period: 'Primary period',
			trend_period: 'Trend period',
			currency: 'Currency',
			tools: 'Analytics Tools',
			insights: 'Insight Summary',
		},
		incidents: {
			subtitle: 'Pending incidents, alerts, and store messages',
			pending: 'Pending incidents',
			pending_hint: 'Needs follow-up',
			today: 'Today incidents',
			today_hint: 'All incidents today',
			alerts: 'Alerts',
			alerts_hint: 'Risk and anomaly notices',
			visible_types: 'Message types',
			unread: 'Unread',
			loaded: 'Loaded',
			status: 'Status',
			live: 'Live',
			tools: 'Incident Tools',
			workflow: 'Primary Actions',
			status_overview: 'Incident Status',
			recent_messages: 'Recent Messages',
			inbox: 'Incident Inbox',
			action_event: 'Handle Incidents',
			action_event_hint: 'Review pending items, appeals, and rechecks',
			action_alert: 'Review Alerts',
			action_alert_hint: 'Find stores with risk or anomalies',
			action_message: 'Message Center',
			action_message_hint: 'View notices, system messages, and notifications',
			refresh: 'Refresh incident overview',
			updated_at: 'Updated at {{time}}',
			not_updated: 'Not updated',
			partial_data: 'Some incident data is unavailable',
			message_load_failed: 'Failed to load messages',
			message_empty: 'No messages in this category',
		},
		account: {
			subtitle: 'Organization, region, language, and support',
			region: 'Region',
			language: 'Language',
			recent_count: 'Recent views',
			support_count: 'Support entries',
			profile: 'Profile',
			preferences: 'Region & Language',
			profile_hint: 'Name, phone, email, and avatar',
			language_hint: 'Chinese / Español México',
			activity: 'Activity',
			support: 'Support',
		},
	},
	wb: {
		evaluation: 'Store Eval',
		free_patrol: 'Free Patrol',
		self_inspect: 'Self-Inspect',
		timed_check: 'Timed Check',
		ai_patrol: 'AI Patrol',
		report_audit: 'Report Audit',
		workorder: 'Work Order',
		reward: 'Rewards',
		custom: 'Custom',
		customize: 'Customize',
		saved: 'Saved',
		saved_local_only: 'Saved locally (cloud sync failed)',
		locked: 'Locked',
		self_check: 'Spot Check',
		cust_analysis: 'Cust. analysis',
		heatmap: 'Heatmap',
		apparel: 'Apparel',
		flow_alert: 'Flow alert',
		member_id: 'Member ID',
		open_store: 'New store',
		announce: 'Announce',
		task: 'Tasks',
		report_in: 'Reports',
		staff: 'Staff',
		cert: 'Certificates',
		university: 'Academy',
		huiting: 'Huiting',
		store_data: 'Store data',
		pic_detect: 'Pic detect',
		cat: {
			patrol: 'Xundiantong',
			customer: 'Traffic',
			enterprise: 'Business',
			other: 'Other',
		},
		editor: {
			title: 'Manage apps',
			cancel: 'Cancel',
			ok: 'Done',
			hint: 'Drag to reorder',
			shown: 'Home apps',
		},
	},
	store_video: {
		tab_video: 'Store video',
		tab_data: 'Store data',
		store_data_unavailable: 'Store data will be replicated separately. This page only covers Store video.',
		organization: 'Organization',
		organization_all: 'All organizations',
		organization_empty: 'No organization data',
		organization_failed: 'Organization filter unavailable: {{reason}}',
		organization_store_count: '{{count}} stores',
		filter: 'Filter',
		search: 'Search',
		search_placeholder: 'Search store name or code',
		favorite_only: 'Favorites',
		summary_one: '{{count}} store in total, online rate {{rate}}',
		summary: '{{count}} stores in total, online rate {{rate}}',
		offline_count: 'offline {{count}}',
		online_count: 'online {{count}}',
		total_count: 'total {{count}}',
		created_at: 'Store creation time',
		open_multi_view: 'Open multi-view',
		sort_title: 'Sort',
		sort_default: 'Default',
		sort_default_ranking: 'Default ranking',
		sort_high_to_low: 'From high to low',
		sort_low_to_high: 'From low to high',
		sort_offline: 'Offline first',
		sort_create: 'Creation time',
		sort_name: 'Store name',
		favorite_store_video: 'Favorite store video',
		favorite_store_data: 'Favorite store data',
		no_collection: 'No collection',
		filter_data: 'Data',
		filter_time: 'Time',
		metric_entry_number: 'Entry Number',
		metric_total_number: 'Total Number',
		metric_total_sales: 'Total Sales',
		metric_ecr: 'ECR',
		metric_events: 'Events',
		metric_turnover_rate: 'Turnover rate',
		time_today: 'Today',
		time_yesterday: 'Yesterday',
		time_week: 'This week',
		time_seven: 'Recent 7 Days',
		time_month: 'This month',
		time_thirty: 'Recent 30 Days',
		calling_store_manager: 'Calling the store manager',
	},
	settings: {
		account: 'Account & language',
		app: 'App information',
		storage: 'Local storage',
		support: 'Support',
		runtime: 'Runtime',
		runtime_app: 'Mobile app',
		runtime_web: 'Web browser',
		version: 'Version',
		version_hint: 'Current frontend package version',
		clear_recent: 'Clear recent views',
		clear_recent_hint: '{{count}} local recent view records',
		clear_recent_success: 'Recent views cleared',
		feedback_hint: 'Submit feedback or a complaint',
		hotline_hint: 'View support options for this region',
		logout: 'Logout',
	},
	mtab: {
		video: {
			brand_full: 'Shanghai Ulucu Electronic Technology Co., Ltd.',
			search_placeholder: 'Search store name or code',
			filter: 'Filter',
			tab_all: 'All',
			tab_fav: 'Favorites',
			summary_one: '{{count}} store · Device online rate: {{rate}}',
			summary: '{{count}} stores · Device online rate: {{rate}}',
			offline_count_one: '{{n}} device offline',
			offline_count: '{{n}} device(s) offline',
			device_online: 'Online',
			device_offline: 'Offline',
			all_online: 'All online',
			no_device: 'No device',
			view_all: 'View all',
		},
		msg: {
			system: 'System',
			event: 'Events',
			examine: 'Inspections',
			critical: 'Key visitors',
			empty: 'No messages in the last 2 days',
		},
		profile: {
			guest: 'Not signed in',
			subtitle: 'Customer demo account',
			album: 'My Album',
			recent: 'Recently Watched',
			repair: 'Online Repair',
			repair_log: 'Repair Log',
			hotline: 'Service Hotline',
			feedback: 'Feedback',
			changelog: 'Changelog',
			settings: 'Settings',
			settings_hint: 'Language, version, storage, and logout',
			recent_empty: 'No recent records',
			recent_view_all: 'View all',
			edit_profile: 'Profile',
			edit_personal_data: 'Edit personal data',
			name: 'Name',
			mobile: 'Phone',
			mobile_phone: 'Mobile phone',
			email: 'Email',
			email_address: 'Email address',
			email_placeholder: 'Enter content',
			edit_avatar: 'Edit avatar',
			save: 'Save',
			save_success: 'Saved',
			save_unavailable: 'Save not yet supported',
			online: 'Online',
			offline: 'Offline',
			hotline_label: 'Customer service hotline',
			call: 'Call',
			feedback_placeholder: 'Enter your suggestion or comment…',
			feedback_submit: 'Submit',
			feedback_required: 'Content required',
			feedback_success: 'Thanks for your feedback',
			changelog_empty: 'No changelog yet',
		},
		rep: {
			pos_input: 'POS Input',
			portrait: 'Profile',
			precise: 'Precise Flow',
			batch: 'Batch Flow',
			realtime: 'Realtime',
			consume: 'Spending',
			distribution: 'Distribution',
			funnel: 'Funnel',
			duration: 'Stay Duration',
			rank: 'Store Rank',
			store_filter: '{{count}} store(s) selected',
			overview: 'Overview',
			mom: 'MoM',
			yoy: 'YoY',
			compare_range: 'Compare period',
			pass_count: 'Pass-by',
			enter_count: 'Entered',
			enter_conv: 'Entry rate',
			try_count: 'Try-on',
			try_conv: 'Try-on rate',
			member_count: 'Members',
			stay_duration: 'Avg stay (min)',
			deal_conv: 'Deal rate',
			leave_count: 'Left',
			invoice_count: 'Transactions',
			amount: 'Revenue',
			commodity_count: 'Items',
			avg_enter: 'Avg entries',
			hour: 'Hour',
			day: 'Day',
			flow_trend: 'Flow trend',
			daily_avg: 'Daily avg',
			peak: 'Peak',
			valley: 'Valley',
		},
	},
	player: {
		hd: 'HD',
		sd: 'SD',
		fill: 'Fill',
		fit: 'Fit',
		live: 'Live',
		playback: 'Playback',
		all: 'All',
		view_legend: 'Legend',
		no_device: 'Select a device',
		no_stream: 'No stream',
		no_history: 'No recording for this day',
		no_record_at_time: 'No recording at this moment',
		playback_started: 'Playback started',
		history_segment_count: '{{count}} segments',
		screenshot_done: 'Screenshot saved',
		fn_screenshot: 'Snapshot',
		fn_intercom: 'Intercom',
		fn_record: 'Record',
		fn_event: 'New Event',
		fn_ptz: 'PTZ',
		fn_pos: 'POS Lookup',
		fn_record_stop: 'Stop Recording',
		recording_started: 'Recording…',
		recording_saved: 'Recording saved',
		cap_unsupported: 'Device does not support this',
		share: 'Share',
		video_init_failed: 'Failed to initialize video...',
	},
	ptz: {
		no_permission: 'No PTZ permission. Ask your admin to enable it in the ulucu console.',
	},
	rename: {
		title: 'Rename channel',
		placeholder: 'Enter new alias',
		success: 'Renamed',
		failed: 'Rename failed',
	},
	channel: {
		select: 'Select channel',
		count: '{{count}} channels',
	},
	store_detail: {
		tab_devices: 'Devices',
		tab_overview: 'Overview',
		copy: 'Copy',
		copied: 'Copied',
		copy_failed: 'Copy failed',
		created_at: 'Created',
		devices_all: 'All',
		devices_online: 'Online',
		devices_offline: 'Offline',
		cat_all: 'All devices',
		cat_camera: 'Cameras',
		cat_audio: 'Audio',
		my_nvr_devices: 'My NVR devices',
		multi_view: 'Multi-view',
		open_video: 'Open video',
		more: 'More',
		status_online: 'Online',
		status_offline: 'Offline',
		offline_hint: 'Device offline, playback unavailable',
		offline_unplayable: 'Device offline, playback unavailable',
		call_owner: 'Call store owner',
		no_phone: 'No phone for this store',
		repair_log: 'Repair history',
		service_hotline: 'Service hotline',
		delete_store: 'Delete store',
		confirm_delete: 'Delete this store?',
		confirm_delete_ok: 'Delete',
		deleted: 'Deleted',
		delete_failed: 'Delete failed',
	},
	repair: {
		title: 'Online Repair',
		store: 'Store',
		contact: 'Contact',
		contact_phone: 'Contact phone',
		store_phone: 'Store phone',
		describe: 'Description',
		optional: 'Optional',
		add_images: 'Add images',
		images_tip: 'Upload images that illustrate the issue so we can troubleshoot faster.',
		tip: 'For faster resolution, contact the on-site solution before submitting a platform repair.',
		submit: 'Submit',
		contact_required: 'Contact name required',
		phone_required: 'Contact phone required',
		describe_required: 'Description required',
		success: 'Repair submitted',
		failed: 'Submit failed',
		over_limit: 'This store has reached the pending repair limit. Please process existing repair records before submitting another one.',
		history: 'Repair history',
	},
	hotline: {
		cn_desc: 'China accounts can call the customer service hotline directly.',
		local_label: 'Local support',
		local_value: 'APAC / Mexico',
		local_desc: 'Mexico and APAC users should not use the China 400 hotline. Submit a support request or contact the local account manager.',
		feedback_action: 'Submit support request',
	},
	inspect: {
		status: 'Status',
		overdue: 'Overdue',
		progress: 'Progress',
	},
	patrol: {
		total_plans: 'Total plans',
		completed: 'Completed',
		overdue: 'Overdue',
		completion_rate: 'Completion rate',
	},
	message: {
		unread_by_category: 'Unread by category',
		unread: 'Unread',
		recent: 'Recent messages',
		cat_all: 'All',
		cat_event: 'Event',
		cat_alarm: 'Alarm',
		cat_examine: 'Inspection',
		cat_system: 'System',
		cat_share: 'Share',
		cat_face: 'Face recognition',
		cat_human_alarm: 'Human alert',
		cat_shop_inspection: 'Store inspection',
		cat_detachment_detection: 'Off-post detection',
		cat_spot_inspection: 'Spot inspection',
		cat_black_list: 'Blacklist',
		cat_youxun_moveai: 'Youxun Move AI',
		cat_youxun_picai: 'Youxun Image AI',
		cat_pos_trade: 'POS transaction',
		cat_youqin: 'Youqin attendance',
		cat_face_mask: 'Mask recognition',
		cat_data_warning: 'Data alert',
		cat_take_place: 'Event trigger',
		cat_youxun_advancedai: 'Youxun Advanced AI',
		cat_youxun_paidui: 'Youxun queueing',
		cat_shelf_analysis: 'Shelf analysis',
	},
	alert: {
		total: 'Total alerts',
		pending: 'Pending',
		handled: 'Handled',
	},
	incident_domain: {
		title: 'Incident workbench',
		subtitle: 'Handle events, alerts, and messages in one place',
		partial_data: 'Some incident data is unavailable',
		alert_unread: 'Unread alerts',
		message_unread: 'Unread messages',
		status_overview: 'Event status overview',
		alert_workbench: 'Alert handling',
		alert_note: 'Alert statistics are connected',
		alert_note_desc: 'Alert detail needs the event type dictionary before it can be opened. For now, use event status and alert messages to locate pending risk.',
		message_workbench: 'Message handling',
		no_messages: 'No messages in this category',
		event_message_hint: '{{count}} event messages are unread. Switch to Messages to handle them.',
	},
	store: {
		all_stores: 'All stores',
		groups: 'Store groups',
		total: 'Total stores',
		online: 'Open',
		with_device: 'Has device',
		has_device: 'Has device',
		stores_in_group: 'stores',
	},
	heatmap: {
		todo_visualization: 'Heatmap visualization TODO',
		todo_desc: 'Raw data fetched (below). Will render with ECharts heatmap later.',
	},
	msg: {
		order_title: 'Reorder message types',
		save: 'Save',
		saved: 'Saved',
		available: 'Available types',
		no_more: '— No more —',
		row_label: '{{label}}, position {{position}} of {{total}}',
		remove_label: 'Remove {{label}}',
		add_label: 'Add {{label}}',
		move_up_label: 'Move {{label}} up',
		move_down_label: 'Move {{label}} down',
		unread_card_label: 'Unread message: {{title}}',
		status: { unread: 'Unread' },
		kp: {
			arrive_time: 'Arrival time',
			store: 'Store',
			name: 'Name',
			sex: 'Gender',
			male: 'Male',
			female: 'Female',
			record: 'Record',
			arrive_n_times: 'Visited {{n}} times',
		},
		pos: {
			fallback: 'Transaction',
			type_1: 'Sale',
			type_2: 'Refund',
			type_3: 'Top-up',
			type_4: 'Loss report',
			type_5: 'Round-off',
			type_6: 'AI anomaly',
			type_7: 'Correction',
			type_8: 'Return',
			type_9: 'Reverse settle',
			type_10: 'Discount',
			type_11: 'Delivery refund',
			type_12: 'Order rejected',
			type_13: 'Abnormal cancel',
			type_14: 'Abnormal return',
			type_15: 'Comp',
		},
	},
	msg_t: {
		system: 'System',
		event: 'Events',
		examine: 'Evaluation',
		key_person: 'Key visitors',
		blacklist: 'Blacklist',
		xundian: 'Store patrol',
		tuogang: 'Off-post',
		pic_ai: 'Image AI',
		move_ai: 'Video AI',
		face_mask: 'No-mask alert',
		data_warn: 'Data alert',
		cert: 'Certificates',
		youschool: 'Academy',
		store_build: 'New store',
		image_exception: 'Image fault',
		alarm: 'Alarm',
		human_alarm: 'Human alert',
		face: 'Face',
		ai_tag_video: 'AI video',
		pos_trade: 'POS trade',
		dianjian: 'Spot check',
	},
	eval: {
		search_ph: 'Search tasks',
		expired_tasks: 'Expired',
		no_active: 'No active tasks',
		no_expired: 'No expired tasks',
		valid_time: 'Valid',
		to: 'to',
		cycle: 'Cycle',
		frequency: 'Frequency',
		times: 'times',
		eval_stores: 'Stores',
		done_stores: 'Done',
		unit_store: '',
		unit_copy: 'pcs',
		progress: 'Progress',
		submit_count: 'Submitted',
		remote_eval: 'Remote',
		onsite_eval: 'On-site',
		view_report: 'Reports',
		detail_title: 'Task detail',
		template: 'Template',
		evaluators: 'Evaluators',
		recent_reports: 'Recent reports',
	},
	rp: {
		tab_records: 'Records',
		tab_levels: 'Rules',
		all_rp: 'All',
		reward: 'Reward',
		penalty: 'Penalty',
		last_7d: 'Last 7 days',
		last_30d: 'Last 30 days',
		last_90d: 'Last 3 months',
		sort_by_create: 'By create time',
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		confirm_delete: 'Delete this rule?',
		deleted: 'Deleted',
		delete_failed: 'Delete failed',
		edit_title: 'Edit rule',
		add_title: 'New rule',
		save: 'Save',
		saved: 'Saved',
		save_failed: 'Save failed',
		type: 'Type',
		level_name: 'Name',
		level_name_ph: 'Enter rule name',
		amount: 'Amount',
		amount_ph: 'Enter amount',
		usage: 'Usage',
		usage_ph: 'Describe how to use this rule',
		title_required: 'Name is required',
		amount_required: 'Valid amount required',
	},
	hot: {
		select_store: 'Store:',
		date: 'Date:',
		pick_store: 'Pick a store first',
		no_device: 'No heatmap devices in this store',
		not_configured: 'No heat zones configured for this device',
		filter_areas: 'Filter zones',
		show_all: 'Show all',
		hide_all: 'Hide all',
		stay_label: 'Stay threshold:',
		seconds: '{{n}}s',
		keliu: 'Visitors',
		stop: 'Stopped',
		stop_rate: 'Stop rate',
		avg_stay: 'Avg stay',
	},
	traffic: {
		total_vehicles: 'Total vehicles',
		avg_plate: 'Avg plate recognition',
		hourly_trend: 'Hourly vehicle trend',
	},
	leavepost: {
		no_records: 'No off-post records on this day',
		duration: 'Duration',
	},
	auth: {
		login_title: 'Sign in',
		account: 'Account',
		account_required: 'Please enter your account',
		password: 'Password',
		password_required: 'Please enter your password',
		login: 'Sign in',
		login_success: 'Signed in',
		login_failed: 'Sign-in failed',
		session_elsewhere: 'It is detected that your account has been logged in elsewhere. Please sign in again.',
		remember_account: 'Remember account',
		logout: 'Logout',
		logged_in_as: 'Signed in as',
		tip_internal_dev: 'Dev mode — calling ulucu internal API (will switch to open platform once credentials are issued)',
	},
	home: {
		welcome: 'Welcome to Ulucu',
		intro: 'Store management client · multilingual (zh / en / es / ar)',
		store_count: '{{count}} stores total',
		has_device: 'has device',
	},
	dashboard: {
		online_rate: 'Device online rate',
		device_status: 'Device status distribution',
	},
	device: {
		total: 'Total',
		online: 'Online',
		offline: 'Offline',
		channels: 'Channels',
		off_time: 'Offline since',
		select_device: 'Select device',
	},
	daterange: {
		today: 'Today',
		'7d': 'Last 7 days',
		'30d': 'Last 30 days',
	},
	cust: {
		tab_portrait: 'Profile',
		tab_precise:  'Precise Flow',
		tab_batch:    'Batch Flow',
		tab_realtime: 'Realtime',
		tab_consume:  'Spending',
		tab_device:   'Device',
		filter: 'Filter',
		current_n_stores: '{{n}} store(s)',
		overview: 'Overview',
		portrait_total: 'Profiles total',
		most_portrait: 'Most common profile',
		unit_person: '',
		member_ratio: 'Member ratio',
		gender_ratio: 'Gender ratio',
		age_ratio: 'Age ratio',
		age_x_gender: 'Age × Gender',
		age_x_identity: 'Age × Identity',
		member: 'Member',
		non_member: 'Non-member',
		male: 'Male',
		female: 'Female',
		precise_wip_title: 'Precise traffic',
		precise_wip_desc: 'Overview + flow / funnel / stay / rank (WIP)',
		mom: 'MoM',
		yoy: 'YoY',
		sub_flow: 'Flow',
		sub_funnel: 'Funnel',
		sub_stay: 'Stay',
		sub_rank: 'Rank',
		gran_hour: 'Hour',
		gran_day: 'Day',
		flow_trend: 'Traffic trend',
		kpi: {
			pass: 'Pass-by',
			enter: 'Entries',
			enter_rate: 'Entry rate',
			try: 'Try-on',
			try_rate: 'Try-on rate',
			member: 'Members',
			stay_avg: 'Avg stay (min)',
			deal_rate: 'Deal rate',
			bind_device: 'Bind exit device',
			daily_avg: 'Daily avg',
			peak: 'Peak ({{date}})',
			valley: 'Trough ({{date}})',
		},
	},
	customer: {
		title: 'Customer Flow',
		date: 'Date',
		pass_count: 'Pass-by',
		enter_count: 'Entered',
		unit: 'people',
		raw_response: 'Raw response',
		hourly_trend: 'Hourly traffic trend',
	},
	member: {
		overview: 'Overview',
		customer_list: 'Customers',
		total: 'Total members',
		new_count: 'New',
		return_count: 'Returning',
		visit_count: 'Visited {{count}} times',
		last_visit: 'Last visit',
		start_from: 'Start date',
		anonymous: 'Anonymous',
	},
	event: {
		range: 'Range',
		total: '{{count}} events',
	},
	event_count: {
		all: 'All',
		wait: 'Waiting',
		wait_handle: 'Action needed',
		destroy: 'Cancelled',
		my: 'My events',
		my_appeal: 'My appeals',
		appeal_audit: 'Appeal review',
		recheck: 'Recheck',
	},
	live: {
		online_devices: 'Devices',
		no_online: 'No devices in this store',
		play_live: 'Play Live',
		get_play_token: 'Get play token',
		play_token_for: 'Play token · ',
		cloud_storage: 'Cloud storage',
		web_limitation: 'Web live video — strategy',
		web_limitation_desc: 'Current app uses AYClient_SDK private protocol; new strategy uses open-platform auth.weburl to get HFLV/HLS URL (browser-playable, 1-2s latency). The PoC below verifies flv.js compatibility in your browser; the real endpoint requires open-platform credentials.',
		token_only_note: 'play_token retrieved (internal API path, for native SDK). Open-platform auth.weburl requires appID/Secret credentials.',
		poc_title: 'HFLV Browser Compatibility PoC',
		poc_intro: 'Verify flv.js + browser can play HFLV',
		poc_intro_desc: 'Validate browser / Capacitor WebView compatibility with public test streams. If flv.js works, we plug in real ulucu endpoints once we get the open-platform appID/Secret. If not, fall back to hls.js (3-5s latency).',
		test_stream: 'Test stream',
		play: 'Play',
		stop: 'Stop',
		reload: 'Reload',
		logs: 'Logs',
		missing_sn: 'Device missing SN, cannot play',
	},
	scan: {
		browser_supported: 'Scanning is available in this browser',
		browser_unsupported: 'This browser does not support scanning',
		browser_supported_desc: 'The web app can use BarcodeDetector when the browser supports it; mobile apps will use native camera scanning.',
		browser_unsupported_desc: 'Use the mobile app or a compatible camera-scanning browser.',
		capacitor_plan: 'The iOS / Android app will use native scanning; the web page only shows compatibility status.',
		start_scan: 'Start scanning',
	},
	modules: {
		dashboard: 'Dashboard',
		device: 'Device',
		store: 'Store',
		live: 'Live Video',
		event: 'Event Center',
		alert: 'Alert',
		inspect: 'Inspection',
		patrol: 'Patrol',
		leavepost: 'Off-Post',
		customer: 'Customer Analytics',
		traffic: 'Traffic Stats',
		heatmap: 'Heatmap',
		pos: 'POS Overlay',
		scan: 'Scan',
		auth: 'Sign in',
		member: 'Members',
		evaluation: 'Evaluation',
		wechatvip: 'WeChat VIP',
		figurewarning: 'Human Alert',
		university: 'Ulucu University',
		staff: 'Staff',
		guard: 'Guard',
		message: 'Messages',
		rewardpunish: 'Rewards & Penalties',
		smartlistening: 'Smart Listening',
		cloudstorage: 'Cloud Storage',
		phonelive: 'Phone Live',
		sharedevice: 'Shared Devices',
		datawarn: 'Data Alerts',
		aipatrol: 'AI Inspection',
		reportaudit: 'Report Audit',
	},
	reportaudit: {
		title: 'Report Audit',
		tab: { audit: 'Audit', self: 'Self-inspection' },
		filter: { store: 'Store', date: 'Date', status: 'Status', template: 'Template' },
		status: { pending: 'Pending', passed: 'Passed', rejected: 'Rejected' },
	},
	changelog: {
		unread: 'New',
		load_more: 'Load more',
		no_more: '— No more —',
	},
	album: {
		empty: 'No screenshots yet',
		local: 'Local screenshots',
		edit: 'Edit',
		delete: 'Delete',
		deleted: 'Deleted',
		delete_failed: 'Delete failed',
		select_first: 'Select photos first',
		selected_n: '{{n}} selected',
		confirm_delete: 'Delete {{n}} selected photo(s)?',
		load_more: 'Load more',
		no_more: '— No more —',
	},
	aipatrol: {
		title: 'AI Inspection',
		banner_title: 'AI Smart Inspection',
		banner_subtitle: '7×24 anomaly detection — no manual rounds',
		unnamed_model: 'Unnamed model',
		sec: { pic: 'Image AI', video: 'Video AI', other: 'Other' },
		app: {
			datacenter: 'Data Center',
			stats: 'Stats',
			report: 'Patrol Reports',
			leavepost: 'Leave-post',
			gallery: 'Gallery',
			alert: 'Alerts',
		},
		dc: {
			title: 'Data Center',
			fav: 'Favorites',
			last7d: 'Last 7 days',
			all_stores: 'All stores',
			all_models: 'All models',
			load_more: 'Tap or pull up to load more',
			no_more: '— No more —',
		},
		kpi: { stores: 'Stores enabled', devices: 'Devices enabled' },
		alarm: {
			title_yesterday: 'Yesterday alarms',
			count_label: 'Count',
			load_more: 'Load more',
			latest: 'Latest alarm stats',
		},
		stats: {
			title: 'Statistics',
			last7d: 'Last 7 days',
			all_tasks: 'All tasks',
			all_stores: 'All stores',
			all_users: 'All inspectors',
			violation_total: 'Total violations',
			violation_type_count: 'Violation types',
			store_total: 'Stores selected',
			patroller_count: 'Inspectors',
			report_submit_count: 'Reports submitted',
			trend: 'Store trend',
			dim_day: 'Day',
			dim_month: 'Month',
			rank: 'Violation rank',
			view_more: 'View more',
			col_item: 'Item',
			col_count: 'Count',
			col_stores: 'Stores',
		},
	},
	rep: {
		title: 'Reports',
		dash: '–',
		last_7d: 'last 7 days',
		today: 'today',
		no_content: 'No content',
		unit: { person: '', percent: '%', yuan: 'CNY' },
		cust: {
			title: 'Customer analysis',
			this_month: 'this month',
			gdrs: 'Pass-by',
			jdkl: 'Entries',
			jzkl: 'Precise entries',
			jdzhl: 'Entry rate',
			xsze: 'Revenue',
		},
		youxun: {
			title: 'Youxun (AI patrol)',
			alarm_count: 'Alarms',
			most_store: 'Top store',
			times: '',
			none: '—',
		},
		xdt: {
			title: 'Xundiantong',
			unit: '',
			examine_submit: 'Submitted',
			examine_waiting: 'Pending review',
			examine_today: "Today's tasks",
			inspect_submit: 'Self-checks',
			inspect_waiting: 'Self-check review',
			inspect_today: 'Self-check today',
			dj_handled: 'Handled',
			dj_waiting: 'Pending',
			dj_expired: 'Overdue',
		},
		event: {
			title: 'Events',
			total: 'Total',
			pending: 'Pending',
			key: 'Top type',
			unit: '',
			none: '—',
		},
		editor: {
			btn: 'Reorder & add',
			title: 'Reorder & add modules',
			cancel: 'Cancel',
			ok: 'Done',
			advanced: 'Advanced',
			shown: 'Shown modules',
			available: 'Available modules',
		},
		advanced: {
			title: 'Youxun advanced',
			search_ph: 'Search model name or ID',
			counter: 'Subscribed {{picked}} / {{total}}',
			saved: 'Saved',
			save_failed: 'Save failed',
		},
	},
	mselect: {
		title: 'Pick devices to play',
		search_ph: 'Search device name',
		counter: '{{online}} online · {{picked}} picked',
		no_online: 'No online devices',
		watch: 'Watch',
	},
	vfilter: {
		title: 'Filter',
		device: 'Store devices',
		has_dev: 'Has device',
		no_dev: 'No device',
		status: 'Device status',
		online: 'Online',
		offline: 'Offline',
		fav_status: 'Favorite',
		faved: 'Favorited',
		unfaved: 'Not favorited',
		sort: 'Sort by',
		sort_create: 'Newest first',
		sort_name: 'A → Z',
		reset: 'Reset',
		ok: 'Apply',
	},
	sov: {
		compare: 'vs',
		rank_title: 'Store ranking',
		b_avg: 'Org avg',
		exceed: 'beats {{pct}}% of stores',
		avg: 'Avg',
		settings_title: 'Store data settings',
		selected_data: 'Selected metrics',
		selected_hint: 'drag to reorder',
		done: 'Done',
		saved: 'Saved',
		save_failed: 'Save failed',
		cat: {
			business: 'Business',
			traffic: 'Traffic',
			event: 'Management',
		},
		p: {
			hour: 'Hr',
			day: 'Day',
			week: 'Wk',
			month: 'Mo',
			quarter: 'Qtr',
		},
		t: {
			jzkl: 'Precise entries',
			gdrs: 'Pass-by',
			gdrs_f: 'Pass-by (F)',
			jdzhl: 'Entry rate',
			xfds: 'Orders',
			xsze: 'Revenue',
			cjl: 'Deal rate',
			sjzs: 'Events',
			dclsjs: 'Pending events',
			zkl: 'Total traffic',
			jtlsc: 'Avg stay (min)',
			kdj: 'Avg ticket',
			ldl: 'Items/order',
		},
	},
	native: {
		common: {
			all: 'All',
			back: 'Back',
			cancel: 'Cancel',
			clear: 'Clear',
			complete: 'Complete',
			confirm: 'Confirm',
			copy: 'Copy',
			date: 'Date',
			default: 'Default',
			details: 'Details',
			edit: 'Edit',
			filter: 'Filter',
			from_high_to_low: 'From high to low',
			level: 'Level',
			no_content: 'No Content',
			no_data: 'No Data',
			online: 'Online',
			offline: 'Offline',
			operation_failed: 'Operation failed',
			organization: 'Organization',
			people: 'People',
			phone: 'Phone',
			pcs: 'Pcs',
			picture: 'Picture',
			refresh: 'Refresh',
			remove_picture: 'Remove picture',
			reset: 'Reset',
			save: 'Save',
			search: 'Search',
			search_by_store_name: 'Search by store name',
			search_history: 'Search history',
			store: 'Store',
			submit: 'Submit',
			video: 'Video',
			view_all: 'View All',
			all_stores: 'All Stores',
			all_status: 'All Status',
			all_tasks: 'All Tasks',
			all_executors: 'All Executors',
		},
		settings: {
			title: 'Setting',
			modify_password: 'Modify Password',
			language_setting: 'Language Setting',
			clear_cache: 'Clear Cache',
			clear_cache_confirm: 'Clear cache?',
			about_us: 'About Us',
			logout: 'Log Out',
			old_password: 'Old Password',
			new_password: 'New Password',
			confirm_password: 'Confirm Password',
		},
		profile: {
			my_album: 'My Album',
			watch_history: 'Watch History',
			online_repair: 'Online Repair',
			repair_record: 'Repair Record',
			setting: 'Setting',
		},
		home: {
			title: 'Home',
			latest_news: 'Latest News',
			assessment: 'Assessment',
			today: 'Today',
			assessment_empty: 'No Content',
			submitted: 'Submit Assessment',
			waiting_approve: 'Waiting For Approving',
			event: 'Event',
			recent_7_days: 'Recent 7 Days',
			events: 'Events',
			pending_events: 'Events to Be Processed',
			key_type: 'Key Event Type',
			ranking: 'Ranking and Adding',
			organization: 'Organization',
			message: 'Message Center',
			system_message: 'System Message',
			event_message: 'Event Message',
			evaluation_message: 'Evaluation Message',
			store_inspection_message: 'Store Inspection Message',
			no_new_message: 'No new message',
			new_message: 'New message',
			no_latest_news: 'No latest news',
			last_update: 'Last Update:',
			no_data_last_2_days: 'No data in last 2 days~',
			management: 'Management',
			statistics: 'Statistics',
			report: 'Report',
			my_assessment: 'My Assessment',
			audits: 'Audits',
			draft_box: 'Draft Box',
			report_status: 'Report Status',
			template: 'Template',
			pending: 'Pending',
			to_be_accepted: 'To be Accepted',
			processed: 'Processed',
			expired: 'Expired',
			deleted: 'Deleted',
			total_events: 'Total Events',
			event_types: 'Event Types',
			message_content_aria: 'Message content',
			message_aria: 'Message',
			create_event: 'Create Event',
			submit: 'Submit',
			select_store: 'Select Store',
			please_choose_store: 'Please Choose Store',
			please_choose_event_type: 'Please Choose Event Type',
			event_scoring: 'Event Scoring',
			priority: 'Priority',
			assign_to: 'Assign to',
			follower: 'Follower',
			remarks_placeholder: 'Remarks Max 3000 characters',
			add_3_pictures: 'Add 3 Pictures at Most',
			confirm: 'Confirm',
			select_all: 'Select All',
			store_name: 'Store Name',
			name: 'Name',
			please_input_key_words: 'Please input key words',
			please_input_key_words_title: 'Please Input Key Words',
			choose_store_required: 'Please choose store',
			choose_event_type_required: 'Please choose event type',
			priority_source_pending: 'Priority source is not ready',
			scoring_required: 'Please choose event scoring',
			property_required: 'Please choose scoring item',
			choose_assignor_required: 'Please select an assignor',
			picture_required: 'Please select or add a picture',
			event_created: 'Created successfully',
			choose_store_first: 'Please choose store first',
			please_select_assignor: 'Please Select an Assignor',
			please_select_follower: 'Please Select Follower',
			select_assignor: 'Select Assignor',
		},
		application: {
			title: 'Application',
			display_title: 'Ranking and Adding',
			display_subtitle: 'Application page display module',
			fixed: 'Pinned',
			saved: 'Application display saved',
			reset_done: 'Default order restored',
			last_visible: 'Keep at least one app visible',
			move_up: 'Move up',
			move_down: 'Move down',
			show: 'Show',
			hide: 'Hide',
			function_intro: 'Function introduction',
			permission_denied: 'You do not have the right to this module.',
			groups: {
				store: 'Store digitization',
				standard: 'Standardized management',
				marketing: 'Smart marketing',
				data: 'Data center',
			},
			items: {
				customer_flow_analysis: 'Customer Flow Analysis',
				traffic_flow: 'Traffic Flow',
				heat_map: 'Heat Map',
				event: 'Event',
				shake_inspection: 'Shake Inspection',
				off_duty_patro: 'Off Duty Patrol',
				timed_inspection: 'Timed Inspection',
				timed_snapshot_inspection: 'Timed Snapshot Inspection',
				assessment: 'Assessment',
				qr_code_scan_superposition: 'QR Code Scan Superposition',
				intelligent_attendance: 'Intelligent Attendance',
				reward_punish: 'Reward & Punish',
				smart_listening: 'Smart Listening',
				shopping_guide: 'Shopping Guide',
				intelligent_classroom: 'Intelligent Classroom',
				customer_flow_alert: 'Customer Flow Alert',
				ranking_display: 'Ranking and display',
				phone_live: 'Phone Live',
				smart_marketing: 'Smart marketing',
				data_center: 'Data center',
				cloud_storage: 'Cloud storage',
			},
		},
		store: {
			device_list: 'Device list',
			data: 'Data',
			access_camera: 'Access to the camera',
			repair_record: 'Repair Record',
			store_creation_time: 'Store creation time',
			camera_setting: 'Camera setting',
			device_layout_preview: 'Preview layout',
			device_layout_list: 'List layout',
			device_is_offline: 'Device is offline',
			offline_time: 'Offline time',
			offline_duration: 'Offline duration',
			setting_unavailable: 'This setting is not available on web yet.',
			camera_name: 'Camera Name',
			cloud_storage: 'Cloud Storage',
			local_storage: 'Local Storage',
			connect_other_wifi: 'Connect With Other Wifi',
			no_longer_use: 'No Longer Use',
			connect_camera_to_store: 'Connect camera to your store',
			compared_previous: 'Compared with the Previous Period',
			events: 'Events',
			events_to_be_processed: 'Events to be Processed',
			data_ranking: 'Data ranking of the store',
			store_data_setting: 'Store data setting',
			data_selected_hint: 'Data selected(Long press and drag to adjust the order)',
			manage_data: 'Manage data',
			max_metrics: 'Select up to {{count}} metrics',
			keep_one_metric: 'Keep at least one metric selected',
			chart_visibility: 'Chart visibility',
			average: 'Average',
			compared_previous_range: '(Compared with the Previous Period{{range}})',
			ranking_detail_with_unit: 'Average {{average}}{{unit}} of enterprises, stores exceed {{exceed}}%',
			period_hour: 'Hour',
			period_day: 'Day',
			period_week: 'Week',
			period_month: 'Month',
			period_quarter: 'Quarter',
			full_storage: 'Full storage',
			mobile_detection_storage: 'Mobile detection storage',
			set_storage_schedule: 'Set storage schedule',
			entry_number: 'Entry Number',
			pieces: '{{count}} pcs',
			ranking_detail: 'Average {{average}} pcs of enterprises, stores exceed {{exceed}}',
			cloud_storage_banner_auto_detect: 'Auto Detect, Cloud Storage',
			cloud_storage_banner_look_back: 'Look back at anytime',
			cloud_storage_banner_encryption: 'Strict Encryption, Security',
			cloud_storage_unavailable_line1: "The device's cloud storage service",
			cloud_storage_unavailable_line2: 'is not yet available.',
			contact_administrator: 'Please contact your administrator.',
			memory_card_recording: 'Turn on memory card recording',
			memory_card_type: 'Select type of memory card',
			internal_storage_space: 'Internal storage space',
			storage_available: 'Available{{value}}',
			storage_total: 'Total{{value}}',
			format_memory_card: 'Format memory card',
			storage_status_normal: 'Normal',
			memory_card_format_hint: 'After formatting, some memory card space will be used to store system files, and the remaining capacity displayed may be less than the actual size of your memory card.',
			memory_card_non_standard_tip: 'Tip: this memory card is a non-standard card. Please use a standard card for your data security',
		},
		repair: {
			record: 'Repair Record',
			date_range: 'Date Range',
			status_submitted: 'Submitted',
			status_processing: 'Processing',
			repair_no: 'Repair No.',
			select_store: 'Select Store',
			contact_person: 'Contact person',
			contact_number: 'Contact number',
			tel: 'Tel',
			store_prefix: 'Store',
			fault_description: 'Fault description',
			submission_time: 'Submission time',
			images: 'Images',
			no_images: 'No images',
			add_picture: 'Add picture',
			fault_tip: 'Please describe the fault phenomenon and related operation steps so our engineer can solve it as soon as possible.',
			pictures_tip: 'Please upload related pictures for reference so that we can solve the issue efficiently.',
		},
		snapshot: {
			timed_snapshot_inspection: 'Timed Snapshot Inspection',
			inspection_statistics: 'Inspection Statistics',
			inspection_data: 'Inspection Data',
			inspection_task: 'Inspection Task',
			create_inspection: 'Create Inspection',
			store_data_statistics: 'Store Data Statistics',
			executor_statistics: 'Executor Statistics',
			start_date: 'Start Date',
			end_date: 'End Date',
			load_failed: 'Load failed',
			apac_only: 'Timed Snapshot Inspection is only connected for APAC.',
			ranking_all_stores: 'Ranking of all Stores',
			total_violations: 'Total Violations',
			all_planned_screenshot: 'All Planned Screenshot',
			current_screenshot: 'Current Screenshot',
			current_processed: 'Current Processed',
			overdue_unprocessed: 'Overdue Unprocessed',
			all_unprocessed: 'All Unprocessed',
			maximum_violations: 'Maximum Violations',
			minimum_violations: 'Minimum Violations',
			ranking: 'Ranking',
			violation_items_ranking: 'Violations Items Ranking',
			items_name: 'Items Name',
			violation_numbers: 'Violation Numbers',
			percentage: 'Percentage',
			account: 'Account',
			full_name_role: 'Full Name (Role)',
			to_be_processed: 'To be Processed',
			processed: 'Processed',
			rank: 'Rank',
			task_status: 'Task Status',
			enabled: 'Enabled',
			disabled: 'Disabled',
			plan_opened_success: 'Plan opened successfully',
			plan_closed_success: 'Plan closed successfully',
			plan_status_failed: 'Plan status update failed',
			delete_task: 'Delete task',
			delete_success: 'Deleted successfully',
			delete_failed: 'Delete failed',
			today_screenshots: 'Today Screenshots',
			today_processed: 'Today Processed',
			total_unprocessed: 'Total Unprocessed',
			total_unqualified: 'Total Unqualified',
			task_store: 'Task Store',
			stores_suffix: 'Stores',
			executor: 'Executor',
			people_suffix: 'People',
			task_time: 'Task Time',
			execution_cycle: 'Execution Cycle',
			task_name: 'Task Name',
			detail_information: 'Detail Information',
			execution_date: 'Execution Date',
			execution_month: 'Execution Month',
			assessment_template: 'Assessment Template',
			select_template: 'Select template',
			store: 'Store',
			select_executor: 'Select executor',
			device_point: 'Device',
			select_device: 'Select device',
			execution_time: 'Execution Time',
			add_time: 'Add time',
			validation_template: 'Please select an assessment template',
			save_success: 'Saved successfully',
			save_failed: 'Save failed',
			qualified: 'Qualified',
			unqualified: 'Unqualified',
			process_success: 'Processed successfully',
			process_failed: 'Process failed',
			mon: 'Mon',
			tues: 'Tues',
			wed: 'Wed',
			thur: 'Thur',
			fri: 'Fri',
			sat: 'Sat',
			sun: 'Sun',
			daily_violation_item: 'Daily Violation Trend (By Violation Item)',
			daily_violation_store: 'Daily Violation Trend (By Store)',
		},
		evaluation: {
			title: 'Assessment',
			management: 'Management',
			assessment_today: 'Assessment for Today',
			store: 'Store',
			assigned_to_me: 'Assigned to Me',
			remote_assessment: 'Remote Assessment',
			onsite_assessment: 'Onsite Assessment',
			my_task: 'My Task',
			ranking: 'Ranking',
			task_progress: 'Task Progress:',
			by_score: 'By Score',
			by_store: 'By Store',
			select_task: 'Select Task',
			select_store: 'Select Store',
			select_user: 'Select user',
			select_stores_count: 'Select({{count}})Stores',
			select_tasks_count: 'Select({{count}})Tasks',
			search_store: 'Search store',
			deselect_all: 'Deselect All',
			keyword_placeholder: 'Please enter a keyword',
			user_keyword_placeholder: 'Please input key words...',
			expired_tasks: 'Expired Tasks',
			no_tasks_in_progress: 'No tasks in progress',
			select_date: 'Select Date',
			today: 'Today',
			recent_7_days: 'Recent 7 Days',
			recent_30_days: 'Recent 30 Days',
			recent_90_days: 'Recent 90 Days',
			recent_180_days: 'Recent 180 Days',
			customize: 'Customize',
			start_date: 'Start Date',
			end_date: 'End Date',
			select_user_count: 'Select({{count}})User',
			select_templates_count: 'Select({{count}})Templates',
			please_select: 'Please Select',
			please_input: 'Please input',
			please_input_keywords: 'Please Input Key Words',
			store_name: 'Store Name',
			name: 'Name',
			select_all: 'Select All',
			location_permission: 'You need to open positioning permission to obtain location of nearby stores',
			reviewer: 'Reviewer',
			submitter: 'Submitter',
			report: 'Report',
			my_assessment: 'My Assessment',
			audits: 'Audits',
			draft_box: 'Draft Box',
			date: 'Date',
			report_status: 'Report Status',
			template: 'Template',
			assessment_details: 'Assessment Details',
			assessment_time: 'Assessment Time',
			score: 'Score',
			assessment_task: 'Assessment Task',
			source: 'Source',
			assessment_content: 'Assessment Content',
			filter_full_score_item: 'Filter Full Score Item',
			standard: 'Standard',
			qualified: 'Qualified',
			unqualified: 'Unqualified',
			passed: 'Passed',
			failed: 'Failed',
			remarks: 'Remarks',
			no_picture: 'No picture',
			no: 'No',
		},
		inspect: {
			title: 'Timed Inspection',
			empty: "You haven't added a store inspection plan yet~",
			add_plan: 'ADD PLAN',
			add_title: 'Add plan',
			plan: 'Plan',
			plan_name: 'Plan name',
			select_store: 'Select Store',
			select_device: 'Select Device',
			equipment_location: 'Equipment location',
			store_inspection_time: 'Store inspection time',
			set_time: 'Set store inspection time',
			submit_plan: 'Submit plan',
			confirm: 'Confirm',
			cancel: 'Cancel',
			select_all: 'Select All',
			store_name: 'Store Name',
			equipment_name: 'Equipment Name',
			search_keywords: 'Please Input Key Words',
			equipment_search: 'Equipment Search',
			no_stores: 'No stores',
			no_devices: 'No equipment',
			store_count: 'Number of store inspected',
			stores: 'Stores',
			inspection_time: 'Store inspection time',
			running_state: 'running state',
			executing: 'Executing',
			closed: 'Closed',
			detail_title: 'Detail of store inspection plan',
			update_time: 'Update time',
			enabled: 'Enabled',
			off_state: 'Off state',
			intelligent: 'Intelligent',
			time: 'Time',
			no_data: 'No Data',
			refresh: 'Refresh',
			plan_opened_success: 'Plan opened successfully',
			plan_closed_success: 'Plan closed successfully',
			plan_status_failed: 'Failed to update plan status',
			picture_preview: 'Picture preview',
			picture_load_failed: 'Failed to load pictures',
			create_event: 'Create event',
			download_picture: 'Download picture',
			intelligent_options: 'Intelligent options',
			intelligent_options_title: 'Please select intelligent options for store inspection',
			intelligent_option_roughly: 'This is roughly the case here',
			intelligent_options_learning: 'Learning more intelligent options...',
			intelligent_options_tip: 'Tip: after activating intelligent options, the store inspection pictures that fail to meet the options will be listed separately. However, if the camera deviates, it will be inaccurate or even invalid. At this time, the intelligent options of the location can be reset.',
			choose_later: 'Choose later',
			device_context_missing: 'Device information is unavailable',
			message_context_missing: 'Message information is unavailable',
			picture_unavailable: 'Picture is unavailable',
			add_success: 'Add plan successfully',
			delete: 'Delete',
			delete_confirm_title: 'Delete plan',
			delete_confirm_body: 'Delete this timed inspection plan?',
			delete_success: 'Plan deleted',
			delete_failed: 'Delete failed',
			load_failed: 'Failed to load timed inspection plans',
			submit_failed: 'Submit failed',
			validation_plan_name: 'Please enter a plan name',
			validation_store: 'Please select a store',
			validation_device: 'Please select equipment',
			validation_time: 'Please select an inspection time',
			validation_user: 'Current user id is missing',
			validation_item: 'Inspection item metadata is incomplete',
			hour: 'Hour',
			minute: 'Minute',
			time_slot_1: 'Please select the first store inspection time',
			time_slot_2: 'Please select the second store inspection time',
			time_slot_3: 'Please select the third store inspection time',
			time_slot_4: 'Please select the fourth store inspection time',
			time_slot_5: 'Please select the fifth store inspection time',
			time_slot_6: 'Please select the sixth store inspection time',
			time_slot_7: 'Please select the seventh store inspection time',
			time_slot_8: 'Please select the eighth store inspection time',
			time_slot_9: 'Please select the ninth store inspection time',
			time_slot_10: 'Please select the tenth store inspection time',
		},
	},
};
